var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 14.5V8.5H7.75V10H9.25V14.5H7V16H13V14.5H10.75ZM10 4C9.7775 4 9.55999 4.06598 9.37498 4.1896C9.18998 4.31321 9.04578 4.48891 8.96064 4.69448C8.87549 4.90005 8.85321 5.12625 8.89662 5.34448C8.94002 5.56271 9.04717 5.76316 9.2045 5.9205C9.36184 6.07783 9.56229 6.18498 9.78052 6.22838C9.99875 6.27179 10.225 6.24951 10.4305 6.16436C10.6361 6.07922 10.8118 5.93502 10.9354 5.75002C11.059 5.56501 11.125 5.3475 11.125 5.125C11.125 4.82663 11.0065 4.54048 10.7955 4.3295C10.5845 4.11853 10.2984 4 10 4Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 19H2.5C2.10218 19 1.72064 18.842 1.43934 18.5607C1.15804 18.2794 1 17.8978 1 17.5V2.5C1 2.10218 1.15804 1.72064 1.43934 1.43934C1.72064 1.15804 2.10218 1 2.5 1H17.5C17.8978 1 18.2794 1.15804 18.5607 1.43934C18.842 1.72064 19 2.10218 19 2.5V17.5C19 17.8978 18.842 18.2794 18.5607 18.5607C18.2794 18.842 17.8978 19 17.5 19ZM2.5 2.5V17.5H17.5V2.5H2.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.70029540b1beef19d9030902c9b375fc.svg";
export { ForwardRef as ReactComponent };